
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ksibxkytufszpgsrapjz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtzaWJ4a3l0dWZzenBnc3JhcGp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA4NjIyNDUsImV4cCI6MjA1NjQzODI0NX0.SpbI7aVttSVgSU4UdBhQnSli93IUzqAFPpQFFySXtWI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
